import { render, staticRenderFns } from "./SelectProduct.vue?vue&type=template&id=2d83df3e&"
import script from "./SelectProduct.vue?vue&type=script&lang=js&"
export * from "./SelectProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d83df3e')) {
      api.createRecord('2d83df3e', component.options)
    } else {
      api.reload('2d83df3e', component.options)
    }
    module.hot.accept("./SelectProduct.vue?vue&type=template&id=2d83df3e&", function () {
      api.rerender('2d83df3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/rentalBookings/widgets/SelectProduct.vue"
export default component.exports